import React from 'react';
import { Route, Redirect } from 'react-router';
import routes from '../routes';
import Restricted from '../../components/auth/Restricted';
import { entityGroupRoutes } from '../helpers';
//screens
import DashboardScreen from '../../screens/General/screens/Dashboard';
import CustomerLoginScreen from '../../screens/Auth/screens/Login';
import CustomerLoginAuthCodeScreen from '../../screens/Auth/screens/LoginAuthCode';
import UserRole from '../../enumerables/user-role';

import ProvidersScreen from 'src/screens/General/screens/Providers/screens/ProviderList';
import ProviderCreateScreen from 'src/screens/General/screens/Providers/screens/ProviderCreate';
import ProviderEditScreen from 'src/screens/General/screens/Providers/screens/ProviderEdit';
import ProviderDetailScreen from 'src/screens/General/screens/Providers/screens/ProviderDetail';

import ServiceTypesScreen from 'src/screens/General/screens/ServiceTypes/screens/ServiceTypeList';
import ServiceTypeCreateScreen from 'src/screens/General/screens/ServiceTypes/screens/ServiceTypeCreate';
import ServiceTypeEditScreen from 'src/screens/General/screens/ServiceTypes/screens/ServiceTypeEdit';

import ServiceLocationScreen from 'src/screens/General/screens/ServiceLocations/screens/ServiceLocationList';
import ServiceLocationCreateScreen from 'src/screens/General/screens/ServiceLocations/screens/ServiceLocationCreate';
import ServiceLocationEditScreen from 'src/screens/General/screens/ServiceLocations/screens/ServiceLocationEdit';

import DistrictsListScreen from 'src/screens/General/screens/Districts/screens/DistrictsList';
import DistrictsCreateScreen from 'src/screens/General/screens/Districts/screens/DistrictCreate';
import DistrictsEditScreen from 'src/screens/General/screens/Districts/screens/DistrictEdit';
import DistrictsInfoScreen from 'src/screens/General/screens/Districts/screens/DistrictInfo';

import VendorsListScreen from 'src/screens/General/screens/Vendors/screens/VendorList';
import VendorsEditScreen from 'src/screens/General/screens/Vendors/screens/VendorEdit';
import VendorsCreatScreen from 'src/screens/General/screens/Vendors/screens/VendorCreate';
import VendorsInfoScreen from 'src/screens/General/screens/Vendors/screens/VendorInfo';

import AgencyInfoScreen from 'src/screens/General/screens/AgencyInfo';
import EmailsLogScreen from 'src/screens/General/screens/EmailsLog/screens/EmailsLogList';

import StudentListScreen from 'src/screens/General/screens/Students/screens/StudentList';
import StudentCreateScreen from 'src/screens/General/screens/Students/screens/StudentCreate';
import StudentEditScreen from 'src/screens/General/screens/Students/screens/StudentEdit';
import StudentInfoScreen from 'src/screens/General/screens/Students/screens/StudentInfo';

import OrderListScreen from 'src/screens/General/screens/Orders/screens/OrderList';
import OrderCreateMultiScreen from 'src/screens/General/screens/Orders/screens/OrderCreateMulti';
import OrderCreateScreen from 'src/screens/General/screens/Orders/screens/OrderCreate';
import OrderEditScreen from 'src/screens/General/screens/Orders/screens/OrderEdit';
import OrderInfoScreen from 'src/screens/General/screens/Orders/screens/OrderDetail';

import InvoiceListScreen from 'src/screens/General/screens/Invoices/screens/InvoiceList';
import InvoiceCreateScreen from 'src/screens/General/screens/Invoices/screens/InvoiceCreate';
import InvoiceEditScreen from 'src/screens/General/screens/Invoices/screens/InvoiceEdit';
import InvoiceInfoScreen from 'src/screens/General/screens/Invoices/screens/InvoiceDetail';

import InvoiceDocsListScreen from 'src/screens/General/screens/InvoicePendings/screens/InvoicePendingList';

import ContractCreateScreen from 'src/screens/General/screens/Contract/screens/ContractCreate';

import ProgramBookCreateScreen from 'src/screens/General/screens/ProgramBook/screens/ProgramBookCreate/index';
import ProgramBookUpdateScreen from 'src/screens/General/screens/ProgramBook/screens/ProgramBookUpdate/index';
import ProgramBookGraphScreen from 'src/screens/General/screens/ProgramBook/screens/ProgramBookGraph';
import ProgramTargetGraphScreen from 'src/screens/General/screens/ProgramBook/screens/ProgramTargetGraph';
import ProgramBookGraphScreenV2 from 'src/screens/General/screens/ProgramBook/screens/ProgramBookGraphV2';
import ProgramBookGraphScreenV3 from 'src/screens/General/screens/ProgramBook/screens/ProgramBookGraphV3';
import ProgramBookGraphScreenV4 from 'src/screens/General/screens/ProgramBook/screens/ProgramBookGraphV4';

import PBTargetCreateScreen from 'src/screens/General/screens/ProgramBook/screens/ProgramBookTargetCreate/index';
import CaseListScreen from 'src/screens/General/screens/Cases/screens/CaseList';
import CaseCreateScreen from 'src/screens/General/screens/Cases/screens/CaseCreate';
import CaseEditScreen from 'src/screens/General/screens/Cases/screens/CaseEdit';
import CaseInfoScreen from 'src/screens/General/screens/Cases/screens/CaseDetail';

import CaseCalendarScreen from 'src/screens/General/screens/Cases/screens/CaseCalendarScreen';
import SeanceListScreen from 'src/screens/General/screens/Seance/screens/SeanceList';
import SeanceEditScreen from 'src/screens/General/screens/Seance/screens/SeanceEdit';

import SubstitutionListScreen from 'src/screens/General/screens/Substitutions/screens/SubstitutionList';
import SubstitutionCreateScreen from 'src/screens/General/screens/Substitutions/screens/SubstitutionCreate';
import SubstitutionEditScreen from 'src/screens/General/screens/Substitutions/screens/SubstitutionEdit';

import PaymentListScreen from 'src/screens/General/screens/Payments/screens/PaymentList';
import PaymentCreateScreen from 'src/screens/General/screens/Payments/screens/PaymentCreate';
import PaymentEditScreen from 'src/screens/General/screens/Payments/screens/PaymentEdit';
import PaymentInfoScreen from 'src/screens/General/screens/Payments/screens/PaymentDetail';

import CreditListScreen from 'src/screens/General/screens/Credits/screens/CreditList';
import CreditEditScreen from 'src/screens/General/screens/Credits/screens/CreditEdit';

import ExpensesListScreen from 'src/screens/General/screens/Expenses/screens/ExpenseList';
import ExpenseCreateScreen from 'src/screens/General/screens/Expenses/screens/ExpenseCreate';
import ExpenseEditScreen from 'src/screens/General/screens/Expenses/screens/ExpenseEdit';
import ExpenseInfoScreen from 'src/screens/General/screens/Expenses/screens/ExpenseDetail';

import InternalListScreen from 'src/screens/General/screens/Internals/screens/InternalList';
import InternalCreateScreen from 'src/screens/General/screens/Internals/screens/InternalCreate';
import InternalEditScreen from 'src/screens/General/screens/Internals/screens/InternalEdit';
import InternalInfoScreen from 'src/screens/General/screens/Internals/screens/InternalDetail';

import PayrollListScreen from 'src/screens/General/screens/Payrolls/screens/PayrollList';
import PayrollEditScreen from 'src/screens/General/screens/Payrolls/screens/PayrollEdit';
import PayrollCreateScreen from 'src/screens/General/screens/Payrolls/screens/PayrollCreate';

import IncentiveListScreen from 'src/screens/General/screens/Incentives/screens/IncentiveList';
import IncentiveEditScreen from 'src/screens/General/screens/Incentives/screens/IncentiveEdit';
import IncentiveCreateScreen from 'src/screens/General/screens/Incentives/screens/IncentiveCreate';

import CalendarScreen from 'src/screens/General/screens/Calendar';

import BonusListScreen from 'src/screens/General/screens/Bonus/screens/BonusList';

import AdminWorkScreen from 'src/screens/General/screens/AdminWork/screens/AdminWorkList';
import AdminWorkCreateScreen from 'src/screens/General/screens/AdminWork/screens/AdminWorkCreate';
import AdminWorkEditScreen from 'src/screens/General/screens/AdminWork/screens/AdminWorkEdit';
import AdminWorkInfoScreen from 'src/screens/General/screens/AdminWork/screens/AdminWorkDetail';

import WageScreen from 'src/screens/General/screens/Wages/screens/WageList';
import WageCreateScreen from 'src/screens/General/screens/Wages/screens/WageCreate';
import WageEditScreen from 'src/screens/General/screens/Wages/screens/WageEdit';
import WageInfoScreen from 'src/screens/General/screens/Wages/screens/WageDetail';

import ReportPayrollScreen from 'src/screens/General/screens/Reports/screens/ReportList';
import ReportPayrollInfoScreen from 'src/screens/General/screens/Reports/screens/ReportDetail';

import DeductionListScreen from 'src/screens/General/screens/Deductions/screens/DeductionList';

import CasesNoConsentListScreen from 'src/screens/General/screens/OccassionNoConsent/CaseList';
import CasesNoPrincipalListScreen from 'src/screens/General/screens/OccassionNoPrincipal/CaseList';

import OrderRemainingHoursReportListScreen from 'src/screens/General/screens/OrderRemainingHoursReport/OrderRemainingHoursReportList';

import OrderExpiredReportListScreen from 'src/screens/General/screens/OrderExpiredReport/OrderExpiredReportList';

import ProviderReportScreen from 'src/screens/General/screens/ProviderReport/ProviderReportList';
import SeanceReportScreen from 'src/screens/General/screens/SeanceReport/SeanceReportList';
import WorkedHoursReportScreen from 'src/screens/General/screens/WorkedHoursReport/WorkedHoursReportList';
import NonBilledSessionsReportScreen from 'src/screens/General/screens/NonBilledSessionsReport/NonBilledSessionsReportList';

import ProviderAnalyticsScreen from 'src/screens/General/screens/ProviderAnalytics/screens/ProviderAnalyticsList';
import ProviderAnalyticsEditScreen from '../../screens/General/screens/ProviderAnalytics/screens/ProviderAnalyticsDetail';

const deductionsRoutes = entityGroupRoutes('DEDUCTION', UserRole.ROLE_ADMIN, {
    list: DeductionListScreen,
    //info: CaseInfoScreen,
});

const programBookRoutes = entityGroupRoutes('PROGRAM_BOOK', UserRole.ROLE_USER, {
    create: ProgramBookCreateScreen,
    edit: ProgramBookUpdateScreen,
    info: ProgramBookGraphScreen,
    v3: ProgramBookGraphScreenV3,
    v2: ProgramBookGraphScreenV2,
    v4: ProgramBookGraphScreenV4,
    target: ProgramTargetGraphScreen,
});

const pBTargetRoutes = entityGroupRoutes('PROGRAM_BOOK_TARGET', UserRole.ROLE_USER, {
    create: PBTargetCreateScreen,
    //info: CaseInfoScreen,
});

const orderExpiredReportListRoutes = entityGroupRoutes('ORDER_EXPIRED_REPORT', UserRole.ROLE_USER, {
    list: OrderExpiredReportListScreen,
});
const invoiceDocsListRoutes = entityGroupRoutes('INVOICE_DOC', UserRole.ROLE_ADMIN, {
    list: InvoiceDocsListScreen,
});

const orderRemainingHoursReportRoutes = entityGroupRoutes('ORDER_REMAINING_HOURS_REPORT', UserRole.ROLE_USER, {
    list: OrderRemainingHoursReportListScreen,
});

const casesNoConsentRoutes = entityGroupRoutes('CASES_NO_CONSENT', UserRole.ROLE_USER, {
    list: CasesNoConsentListScreen,
    //info: CaseInfoScreen,
});

const casesNoPrincipalRoutes = entityGroupRoutes('CASES_NO_PRINCIPAL', UserRole.ROLE_USER, {
    list: CasesNoPrincipalListScreen,
    //info: CaseInfoScreen,
});

const providerReportRoutes = entityGroupRoutes('PROVIDER_REPORT', UserRole.ROLE_USER, {
    list: ProviderReportScreen,
});
const seanceReportRoutes = entityGroupRoutes('SEANCE_REPORT', UserRole.ROLE_USER, {
    list: SeanceReportScreen,
});

const workedHoursReportRoutes = entityGroupRoutes('WORKED_HOURS_REPORT', UserRole.ROLE_USER, {
    list: WorkedHoursReportScreen,
});

const nonBilledSessionsReportRoutes = entityGroupRoutes('NON_BILLED_SESSIONS_REPORT', UserRole.ROLE_USER, {
    list: NonBilledSessionsReportScreen,
});

const wagesRoutes = entityGroupRoutes('WAGE', UserRole.ROLE_ADMIN, {
    list: WageScreen,
    edit: WageEditScreen,
    info: WageInfoScreen,
    create: WageCreateScreen,
});

const casesRoutes = entityGroupRoutes('CASE', UserRole.ROLE_ADMIN, {
    list: CaseListScreen,
    edit: CaseEditScreen,
    info: CaseInfoScreen,
    create: CaseCreateScreen,
});
const ReportPayrollRoutes = entityGroupRoutes('REPORT_PAYROLL', UserRole.ROLE_ADMIN, {
    list: ReportPayrollScreen,
    info: ReportPayrollInfoScreen,
});

const payrollRoutes = entityGroupRoutes('PAYROLL', UserRole.ROLE_ADMIN, {
    list: PayrollListScreen,
    edit: PayrollEditScreen,
    // info: CaseInfoScreen,
    create: PayrollCreateScreen,
});

const incentiveRoutes = entityGroupRoutes('INCENTIVE', UserRole.ROLE_ADMIN, {
    list: IncentiveListScreen,
    edit: IncentiveEditScreen,
    create: IncentiveCreateScreen,
});

const creditsRoutes = entityGroupRoutes('CREDIT', UserRole.ROLE_ADMIN, {
    list: CreditListScreen,
    edit: CreditEditScreen,
});

const paymentsRoutes = entityGroupRoutes('PAYMENT', UserRole.ROLE_ADMIN, {
    list: PaymentListScreen,
    edit: PaymentEditScreen,
    info: PaymentInfoScreen,
    create: PaymentCreateScreen,
});

const substitutionRoutes = entityGroupRoutes('SUBSTITUTION', UserRole.ROLE_ADMIN, {
    list: SubstitutionListScreen,
    edit: SubstitutionEditScreen,
    create: SubstitutionCreateScreen,
});

const invoiceRoutes = entityGroupRoutes('INVOICE', UserRole.ROLE_USER, {
    list: InvoiceListScreen,
    edit: InvoiceEditScreen,
    info: InvoiceInfoScreen,
    create: InvoiceCreateScreen,
});

const contractRoutes = entityGroupRoutes('CONTRACT', UserRole.ROLE_USER, {
    create: ContractCreateScreen,
});

const ordersRoutes = entityGroupRoutes('ORDER', UserRole.ROLE_USER, {
    list: OrderListScreen,
    edit: OrderEditScreen,
    info: OrderInfoScreen,
    create: OrderCreateMultiScreen,
});

const vendorsRoutes = entityGroupRoutes('VENDOR', UserRole.ROLE_ADMIN, {
    list: VendorsListScreen,
    edit: VendorsEditScreen,
    create: VendorsCreatScreen,
    info: VendorsInfoScreen,
});
const providersRoutes = entityGroupRoutes('PROVIDER', UserRole.ROLE_USER, {
    list: ProvidersScreen,
    edit: ProviderEditScreen,
    create: ProviderCreateScreen,
    info: ProviderDetailScreen,
});
const providerAnalyticsRoutes = entityGroupRoutes('PROVIDER_ANALYTICS', UserRole.ROLE_ADMIN, {
    list: ProviderAnalyticsScreen,
});

const servicesTypesRoutes = entityGroupRoutes('SERVICE_TYPE', UserRole.ROLE_ADMIN, {
    list: ServiceTypesScreen,
    edit: ServiceTypeEditScreen,
    create: ServiceTypeCreateScreen,
});
const servicesLocationsRoutes = entityGroupRoutes('SERVICE_LOCATION', UserRole.ROLE_ADMIN, {
    list: ServiceLocationScreen,
    edit: ServiceLocationEditScreen,
    create: ServiceLocationCreateScreen,
});
const districtsRoutes = entityGroupRoutes('DISTRICT', UserRole.ROLE_ADMIN, {
    list: DistrictsListScreen,
    edit: DistrictsEditScreen,
    create: DistrictsCreateScreen,
    info: DistrictsInfoScreen,
});
const expensesRoutes: any = entityGroupRoutes('EXPENSE', UserRole.ROLE_ADMIN, {
    list: ExpensesListScreen,
    edit: ExpenseEditScreen,
    create: ExpenseCreateScreen,
    info: ExpenseInfoScreen,
});
const adminWorkRoutes: any = entityGroupRoutes('ADMIN_WORK', UserRole.ROLE_ADMIN, {
    list: AdminWorkScreen,
    create: AdminWorkCreateScreen,
    edit: AdminWorkEditScreen,
    info: AdminWorkInfoScreen,
});

const bonusRoutes: any = entityGroupRoutes('BONUSE', UserRole.ROLE_ADMIN, {
    list: BonusListScreen,
});

const internalsRoutes: any = entityGroupRoutes('INTERNAL', UserRole.ROLE_ADMIN, {
    list: InternalListScreen,
    edit: InternalEditScreen,
    create: InternalCreateScreen,
    info: InternalInfoScreen,
});
const studentsRoutes = entityGroupRoutes('STUDENT', UserRole.ROLE_USER, {
    list: StudentListScreen,
    // edit: StudentEditScreen,
    info: StudentInfoScreen,
    //  create: StudentCreateScreen,
});
const generalRoutes = [
    <Redirect exact key={`red${routes.HOME}`} from={routes.HOME} to={routes.DASHBOARD} />,
    <Route exact key={routes.LOGIN_CUSTOMER} path={routes.LOGIN_CUSTOMER} render={() => <CustomerLoginScreen />} />,
    <Route exact key={routes.LOGIN_CODE} path={routes.LOGIN_CODE} render={() => <CustomerLoginAuthCodeScreen />} />,
    <Route
        exact
        key={routes.AGENCY_INFO}
        path={routes.AGENCY_INFO}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <AgencyInfoScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.CASE_CALENDAR}
        path={routes.CASE_CALENDAR}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <CaseCalendarScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.STUDENT_EDIT}
        path={routes.STUDENT_EDIT}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <StudentEditScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.STUDENT_CREATE}
        path={routes.STUDENT_CREATE}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <StudentCreateScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.EMAILS_LOG}
        path={routes.EMAILS_LOG}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <EmailsLogScreen {...props} />
            </Restricted>
        )}
    />,

    <Route
        exact
        key={routes.SEANCES_LIST}
        path={routes.SEANCES_LIST}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_USER }}>
                <SeanceListScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.SEANCE_EDIT}
        path={routes.SEANCE_EDIT}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <SeanceEditScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.ORDER_CREATE_OLD}
        path={routes.ORDER_CREATE_OLD}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <OrderCreateScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.CALENDAR}
        path={routes.CALENDAR}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <CalendarScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.DASHBOARD}
        path={routes.DASHBOARD}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_USER }}>
                <DashboardScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.PROVIDER_ANALYTICS_LIST}
        path={routes.PROVIDER_ANALYTICS_LIST}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <ProviderAnalyticsScreen {...props} />
            </Restricted>
        )}
    />,
    <Route
        exact
        key={routes.PROVIDER_ANALYTICS_EDIT}
        path={routes.PROVIDER_ANALYTICS_EDIT}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <ProviderAnalyticsEditScreen {...props} />
            </Restricted>
        )}
    />,
    ...servicesLocationsRoutes,
    ...servicesTypesRoutes,
    ...studentsRoutes,
    ...vendorsRoutes,
    ...districtsRoutes,
    ...ordersRoutes,
    ...casesRoutes,
    ...substitutionRoutes,
    ...invoiceRoutes,
    ...contractRoutes,
    ...creditsRoutes,
    ...paymentsRoutes,
    ...providersRoutes,
    ...adminWorkRoutes,
    ...expensesRoutes,
    ...internalsRoutes,
    ...payrollRoutes,
    ...ReportPayrollRoutes,
    ...deductionsRoutes,
    ...casesNoConsentRoutes,
    ...casesNoPrincipalRoutes,
    ...providerReportRoutes,
    ...seanceReportRoutes,
    ...workedHoursReportRoutes,
    ...nonBilledSessionsReportRoutes,
    ...orderExpiredReportListRoutes,
    ...orderRemainingHoursReportRoutes,
    ...wagesRoutes,
    ...invoiceDocsListRoutes,
    ...programBookRoutes,
    ...pBTargetRoutes,
    ...bonusRoutes,
    ...incentiveRoutes,
    /* <Route
        exact
        key={''}
        path={''}
        render={(props) => (
            <Restricted redirectTo={routes.LOGIN_CUSTOMER} authParams={{ action: UserRole.ROLE_ADMIN }}>
                <NoMatchScreen />
            </Restricted>
        )}
    />,*/
];

export default generalRoutes;
